import React, { FC } from 'react';
import {
  CardInfo,
  CardInfoItem,
  CardInfoValueType,
  FlexItem,
  H3,
} from '@erecruit/ui-kit';
import { Intl } from '@erecruit/core';
import { Resources, AppPermissions } from '@erecruit/types';
import { Authorize } from '@erecruit/modules';
import { CustomFieldRenderer } from '@erecruit/modules';
import SectionContextMenu from '../../../PositionRecord/components/SectionContextMenu';
import { MatchRecordSection } from '../../types';

const { FormattedMessage } = Intl;

export interface AdditionalInfoSectionProps {
  data: Resources.CustomField[];
  onEdit(section: MatchRecordSection): void;
}

const AdditionalInfoSection: FC<AdditionalInfoSectionProps> = props => {
  const { data, onEdit } = props;
  const cardInfos = data.map(customField => (
    <CardInfoItem
      key={customField.id}
      label={customField.name}
      type={CardInfoValueType.Custom}
      value={
        <H3>
          <CustomFieldRenderer
            mode="view"
            {...customField}
            value={customField.value}
          />
        </H3>
      }
    />
  ));

  return (
    <FlexItem>
      <CardInfo
        title={
          <H3 align="center">
            <FormattedMessage
              id={messageIds.vms.matchRecord.additionalInfo.title}
            />
          </H3>
        }
        extra={
          <Authorize
            permission={`${AppPermissions.ViewMatches} & ${AppPermissions.EditMatchAdditionalInfo}`}
          >
            <SectionContextMenu section="additionalInfo" onEdit={onEdit} />
          </Authorize>
        }
      >
        {cardInfos}
      </CardInfo>
    </FlexItem>
  );
};

export default AdditionalInfoSection;
